// @core/api/endpoints/analytics/delete_report.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/analytics';

/**
 * Delete report
 * Deletes a generated report and its download file.
 */
export async function DeleteReport(
  report_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/analytics/reports/:report_id`;
  requestPath = requestPath.replace(':report_id', encodeURIComponent(report_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
